import { writeBatch } from '../masks/batch';

/*
 * Spore analysis's batch (components/workbench/microscopy/MicroscopyMode.js; the
 * generic helpers are utils/masks/batch.js): its storage key, and the batch
 * of one isolate's micrographs -- built the same way by the workbench's
 * isolate gallery (components/spores/SporeSources.js) and by Home's
 * Microscopy tab (components/hub/tabs/MicroscopyTab.js), so that a micrograph
 * opened from either has the isolate's others one Next image away.
 */
export const SPORE_BATCH_KEY = 'mb_spore_batch';

/** How a batch names its isolate: lab code and ISO code. */
export const isolateLabel = item => [item?.lab_code, item?.specimen_code].filter(Boolean).join(' · ');

/** The record an upload is filed with: the isolate's collection, intake or strain. */
export function originLink(specimen) {
  if (!specimen) return null;
  if (specimen.sample_id) return { kind: 'sample', id: specimen.sample_id };
  if (specimen.external_id) return { kind: 'external', id: specimen.external_id };
  if (specimen.strain_id) return { kind: 'strain', id: specimen.strain_id };
  return null;
}

/** The batch of an isolate's micrographs (its dossier's `microscopy`), each marked by whether a spore analysis is saved. */
export function isolateBatch(item, dossier) {
  const measured = new Set((dossier?.spore_analyses || []).map(a => a.image_id));
  const images = (dossier?.microscopy || []).map(m => ({ ...m, analysed: measured.has(m.image_id) }));
  return {
    source: 'isolate', label: item ? isolateLabel(item) || item.specimen_code || '' : '',
    specimenId: item?.specimen_id, origin: originLink(dossier?.specimen), images,
  };
}

/** Hands the isolate's micrographs to the workbench as its batch, before one of them is opened there. */
export function startIsolateBatch(item, dossier) {
  const batch = isolateBatch(item, dossier);
  writeBatch(SPORE_BATCH_KEY, batch.images.length ? batch : null);
  return batch;
}
